module.exports = __webpack_public_path__ + "static/media/stat520p_pset1.60818d1b.pdf";